import React, { useEffect } from "react";

import { useSelector } from "react-redux";
import ProcedureWorkInstructionViewer from "./ProcedureWorkInstructionViewer";
import ViewAction from "./ViewAction";
import PDFViewer from "./PDFViewer";

export default function SOPPDFViewer(props) {
  const { opened } = props;

  const selectedDoc = useSelector((state) => state.SOPViewer.selectedDoc);

  useEffect(() => {
    const cancelEvent = (e) => {
      e.preventDefault();
    };

    const printScreen = (e) => {
      if (e.key === "PrintScreen") {
        navigator.clipboard.writeText("");
      }
    };

    document.addEventListener("selectstart", cancelEvent);
    document.addEventListener("dragstart ", cancelEvent);
    document.addEventListener("keyup", printScreen);
    return () => {
      document.removeEventListener("selectstart", cancelEvent);
      document.removeEventListener("dragstart", cancelEvent);
      document.removeEventListener("keyup", printScreen);
    };
  }, []);

  if (selectedDoc) {
    if (selectedDoc.type == "1" || selectedDoc.type == "4") {
      // return <ProcedureWorkInstructionViewer opened={opened} />;
      // return <PDFViewer />;
      return <PDFViewer />;
    } else if (selectedDoc.action == "view") {
      // return <ViewAction />;
      // return <ProcedureWorkInstructionViewer opened={opened} />;
      return <PDFViewer />;
    } else {
      return <div />;
    }
  } else {
    return <div />;
  }
}
